import React, { Component, ErrorInfo, ReactElement } from 'react';
import { Message } from '@messageformat/react';
import { Alert } from '@op/opds.opux';
import { cleanSessionStorage } from './util/commonUtil';

interface ErrorBoundaryProps {
  children?: ReactElement;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
  }

  public render() {
    if (this.state.hasError) {
      cleanSessionStorage();
      return (
        <Alert type="critical" contentType="dynamic">
          <Message id="yleiset:virhe" />
        </Alert>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
